"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledItemTicker = exports.NameLabelStyle = exports.StyledInfo = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var font = {
  size: {
    small: '12px',
    medium: '14px',
    large: '14px',
    xl: '20px'
  },
  weight: {
    normal: 400,
    bold: 500
  }
};
var infoSizeStyles = {
  small:
  /*#__PURE__*/
  (0, _reactEmotion.css)("display:none;"),
  medium:
  /*#__PURE__*/
  (0, _reactEmotion.css)("margin-top:4px;font-size:11px;"),
  large:
  /*#__PURE__*/
  (0, _reactEmotion.css)("margin-top:4px;font-size:12px;")
};

var infoStyles = function infoStyles(_ref) {
  var color = _ref.theme.color,
      size = _ref.size;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)(infoSizeStyles[size], "\n  color:", color.black3, ";")
  );
};

var StyledInfo = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-1j550lx0"
})(infoStyles));
exports.StyledInfo = StyledInfo;
var imgSizeStyles = {
  small:
  /*#__PURE__*/
  (0, _reactEmotion.css)("width:26px;height:26px;border-radius:13px;margin-right:10px;"),
  medium:
  /*#__PURE__*/
  (0, _reactEmotion.css)("width:28px;height:28px;border-radius:14px;margin-right:12px;"),
  large:
  /*#__PURE__*/
  (0, _reactEmotion.css)("width:36px;height:36px;border-radius:18px;margin-right:12px;")
};

var nameLabelStyle = function nameLabelStyle(_ref2) {
  var size = _ref2.size,
      mode = _ref2.mode;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;flex-direction:row;align-items:center;font-size:", font.size[size], ";", mode === 'dark' ? 'color: #e3e3e3;' : '')
  );
};

var NameLabelStyle =
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-1j550lx1"
})(nameLabelStyle);
exports.NameLabelStyle = NameLabelStyle;

var styles = function styles(_ref3) {
  var color = _ref3.theme.color,
      size = _ref3.size;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;align-items:center;font-size:", font.size[size], ";font-weight:", font.weight.normal, ";color:", color.black1, ";img{", imgSizeStyles[size], "}")
  );
};

var StyledItemTicker = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("span", {
  target: "css-1j550lx2"
})(function (_ref4) {
  var theme = _ref4.theme;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("background-color:", theme.color.grey2, ";font-size:10px;padding:3px 8px;border-radius:3px;")
  );
}));
exports.StyledItemTicker = StyledItemTicker;

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-1j550lx3"
})(styles));

exports.default = _default;